module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Sport Aluminum + Walnut Open.37be53e3.png";